import Modal from "../../components/Base/Modal";
import { FiInfo, FiX } from "react-icons/fi";

interface PropsI {
    showModal: boolean;
    onClose : ()=>void;
    pension: any;
}

const CalculatedPensionModal = ({ showModal, onClose, pension }: PropsI) => {
    return (
        <Modal
            showModal={showModal}
            onClose={onClose}
            className="transaction-summary-modal"
        >
            <div className="modal-head">
                <div className="flex items-center">
                    Your Calculated Pension
                </div>
                <button className="btn btn-text" onClick={onClose}>
                    <FiX className="text-3xl" />
                </button>
            </div>
            <div className="modal-body">
                <ul className="mb-10">
                    <li className="modal-item">
                        <span className="modal-item-left">Lump Sum</span>
                        <span className="modal-item-right">{pension.lumpSum}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Description</span>
                        <span className="modal-item-right">{pension.monthlyPension}</span>
                    </li>
                    <li className="text-center my-8 mx-auto">
                        <button className="btn btn-primary mx-auto" onClick={onClose}>
                            Ok
                        </button>
                    </li>
                </ul>
            </div>
            <div>
            </div>
        </Modal>
    )
}

export default CalculatedPensionModal;